import { render, staticRenderFns } from "./shopRegister.vue?vue&type=template&id=3f057836&scoped=true"
import script from "./shopRegister.vue?vue&type=script&lang=js"
export * from "./shopRegister.vue?vue&type=script&lang=js"
import style0 from "./shopRegister.vue?vue&type=style&index=0&id=3f057836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f057836",
  null
  
)

export default component.exports